module.exports = __webpack_public_path__ + "static/media/times-white.4a091c38.svg";